/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import TextEditor from "../../components/TextEditor";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import Select from "react-select";
import { message } from "antd";
import { fetchAllUsers, fetchUserById } from "../../services/userService";
import { createBlog } from "../../services/blogService";
import { jwtDecode } from "jwt-decode";

const AddBlog = () => {
  const navigate = useNavigate();

  const [title, setTitle] = useState("");
  const [authorName, setAuthorName] = useState("");
  const [authorID, setAuthorId] = useState("");
  const [blogCategory, setBlogCategory] = useState("");
  const [subCategory, setSubCategory] = useState("");
  const [tags, setTags] = useState("");
  const [status, setStatus] = useState("");
  const [description, setDescription] = useState("");
  const [uploadedFile, setUploadedFile] = useState(null);

  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedAuthor, setSelectedAuthor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authors, setAuthors] = useState([]);
  const [loggedInUserData, setLoggedInUserData] = useState(null);

  // ✅ Fetch logged-in user
  useEffect(() => {
    const fetchAndSetUser = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const decoded = jwtDecode(token);
          const user = await fetchUserById(decoded.id);
          setLoggedInUserData(user);
        } catch (error) {
          console.error("Error decoding token or fetching user:", error);
          localStorage.removeItem("token");
          setLoggedInUserData(null);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    };
    fetchAndSetUser();
  }, []);

  // ✅ Fetch authors
  useEffect(() => {
    const fetchAuthors = async () => {
      try {
        const users = await fetchAllUsers();
        const mapped = users.map((user) => ({
          userid: user.user_id,
          username: user.user_name,
          user_email: user.user_email,
        }));
        setAuthors(mapped);
      } catch (err) {
        console.error("Failed to fetch authors:", err);
      }
    };
    fetchAuthors();
  }, []);

  const filteredAuthors = authors.filter(
    (author) =>
      author.username.toLowerCase().includes(searchTerm.toLowerCase()) ||
      author.user_email.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const blog = [
    { value: "health", label: "Health Care" },
    { value: "child", label: "Child" },
    { value: "safety", label: "Safety" },
  ];

  const category = [
    { value: "healthcare", label: "Health Care" },
    { value: "corona", label: "Corona Virus" },
  ];

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !title ||
      !authorName ||
      !blogCategory ||
      !subCategory ||
      !status ||
      !description
    ) {
      message.error("Please fill all required fields before submitting");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("author_name", authorName);
    formData.append("author_id", authorID);
    formData.append("category", blogCategory);
    formData.append("sub_category", subCategory);
    formData.append("tags", tags);
    formData.append("status", status);
    formData.append("description", description);

    if (loggedInUserData?.user_email) {
      formData.append("addedbyemail", loggedInUserData.user_email);

      // Updated parameter logic for all three roles
      let parameter;
      if (loggedInUserData?.user_role === "1") {
        parameter = "Admin";
      } else if (loggedInUserData?.user_role === "2") {
        parameter = "Department";
      } else {
        parameter = "Faculty"; // New role
      }
      formData.append("parameter", parameter);
    }

    if (uploadedFile) {
      formData.append("image", uploadedFile);
    }

    if (loggedInUserData?.user_role === "1") {
      formData.append("approved_level", "1");
    } else if (loggedInUserData?.user_role === "2") {
      formData.append("approved_level", "2");
    } else {
      formData.append("approved_level", "3");
    }

    // 🪵 Debug what’s being sent
    for (let [key, value] of formData.entries()) {
      console.log(`${key}:`, value);
    }

    try {
      console.log(formData);
      await createBlog(formData);
      message.success("Blog created successfully!");
      navigate("/blogs");
    } catch (error) {
      console.error("Error creating blog:", error);
      message.error("Something went wrong while creating the blog.");
    }
  };

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <Sidebar
          id="menu-item11"
          id1="menu-items11"
          activeClassName="add-blog"
        />

        <div className="page-wrapper">
          <div className="content">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="#">Blog </Link>
                    </li>
                    <li className="breadcrumb-item">
                      <FeatherIcon icon="chevron-right" />
                    </li>
                    <li className="breadcrumb-item active">Add Blogs </li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="card-body">
                    <form onSubmit={handleSubmit} encType="multipart/form-data">
                      <div className="row">
                        <div className="col-12">
                          <div className="form-heading">
                            <h4>Blog Details</h4>
                          </div>
                        </div>

                        {/* Title */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Blog Title <span className="login-danger">*</span>
                            </label>
                            <input
                              className="form-control"
                              type="text"
                              value={title}
                              onChange={(e) => setTitle(e.target.value)}
                              required
                            />
                          </div>
                        </div>

                        {/* Author */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Author <span className="login-danger">*</span>
                            </label>
                            <div className="dropdown">
                              <div
                                className="form-control d-flex align-items-center justify-content-between"
                                style={{ cursor: "pointer" }}
                                onClick={() => setIsOpen(!isOpen)}
                              >
                                {selectedAuthor ? (
                                  <span>
                                    {selectedAuthor.username} -{" "}
                                    {selectedAuthor.user_email}
                                  </span>
                                ) : (
                                  <span className="text-muted">
                                    Select an author
                                  </span>
                                )}
                                <i
                                  className={`bi bi-chevron-${
                                    isOpen ? "up" : "down"
                                  }`}
                                ></i>
                              </div>

                              {isOpen && (
                                <div
                                  className="dropdown-menu show w-100"
                                  style={{
                                    maxHeight: "300px",
                                    overflowY: "auto",
                                  }}
                                >
                                  <div className="px-2 py-1 sticky-top bg-white">
                                    <input
                                      type="text"
                                      className="form-control form-control-sm mb-2"
                                      placeholder="Search author..."
                                      value={searchTerm}
                                      onChange={(e) =>
                                        setSearchTerm(e.target.value)
                                      }
                                      autoFocus
                                      onClick={(e) => e.stopPropagation()}
                                    />
                                  </div>
                                  {filteredAuthors.length > 0 ? (
                                    filteredAuthors.map((author) => (
                                      <button
                                        key={author.userid}
                                        type="button"
                                        className={`dropdown-item ${
                                          selectedAuthor?.userid ===
                                          author.userid
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() => {
                                          setSelectedAuthor(author);
                                          setAuthorName(author.username);
                                          setAuthorId(author.userid);
                                          setIsOpen(false);
                                          setSearchTerm("");
                                        }}
                                      >
                                        {author.username} - {author.user_email}
                                      </button>
                                    ))
                                  ) : (
                                    <div className="dropdown-item text-muted">
                                      No matching author found
                                    </div>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Category */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Blog Category{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <Select
                              options={blog}
                              onChange={(e) => setBlogCategory(e.value)}
                              placeholder="Select Category"
                            />
                          </div>
                        </div>

                        {/* Sub Category */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Blog Sub Category{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <Select
                              options={category}
                              onChange={(e) => setSubCategory(e.value)}
                              placeholder="Select Sub Category"
                            />
                          </div>
                        </div>

                        {/* Tags */}
                        <div className="col-md-6">
                          <div className="form-group local-forms">
                            <label>
                              Tags <small>(comma separated)</small>{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              value={tags}
                              onChange={(e) => setTags(e.target.value)}
                            />
                          </div>
                        </div>

                        {/* Status */}
                        <div className="col-md-6">
                          <div className="form-group select-gender">
                            <label className="gen-label">
                              Blog Status{" "}
                              <span className="login-danger">*</span>
                            </label>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="status"
                                  value="active"
                                  onChange={(e) => setStatus(e.target.value)}
                                  className="form-check-input"
                                />{" "}
                                Active
                              </label>
                            </div>
                            <div className="form-check-inline">
                              <label className="form-check-label">
                                <input
                                  type="radio"
                                  name="status"
                                  value="inactive"
                                  onChange={(e) => setStatus(e.target.value)}
                                  className="form-check-input"
                                />{" "}
                                Inactive
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Description */}
                        <div className="col-12">
                          <div className="form-group summer-mail">
                            <TextEditor
                              value={description}
                              onChange={setDescription}
                            />
                          </div>
                        </div>

                        {/* Image */}
                        <div className="col-12">
                          <div className="form-group local-top-form">
                            <label className="local-top">
                              Blog Image <span className="login-danger">*</span>
                            </label>
                            <div className="settings-btn upload-files-avator">
                              {uploadedFile && (
                                <span className="ms-3">
                                  {uploadedFile.name}
                                </span>
                              )}
                              <input
                                type="file"
                                accept="image/*"
                                name="image"
                                id="file"
                                onChange={(e) =>
                                  setUploadedFile(e.target.files[0])
                                }
                                className="hide-input"
                                required
                              />
                              <label htmlFor="file" className="upload">
                                Choose File
                              </label>
                            </div>
                          </div>
                        </div>

                        {/* Submit */}
                        <div className="col-12">
                          <div className="doctor-submit text-end">
                            <button
                              type="submit"
                              className="btn btn-primary submit-form me-2"
                            >
                              Publish Blog
                            </button>
                            <Link
                              to="/blogs"
                              className="btn btn-primary cancel-form"
                            >
                              Cancel
                            </Link>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="sidebar-overlay" data-reff="" />
    </>
  );
};

export default AddBlog;
